import React from 'react';

import styled from '@emotion/styled';
import { useTranslations } from 'next-intl';

import {
  useBlockchain,
  useDepositsOrThrow,
  useUnstakedTokens,
} from '../../hooks';
import { ICommandDefinition } from '../commands';
import {
  CommandLineEntry,
  CommandButton,
  CommandLineEntryStack,
} from '../common';
import { useTerminal } from '../TerminalProvider';

import { StakingConsole } from '.';

const ConsoleMessage = styled.span`
  white-space: normal;
`;

export const ConnectedStakingConsole = () => {
  const blockchain = useBlockchain();
  const { tokenIds: stakedTokens } = useDepositsOrThrow();
  const { tokenIds: unstakedTokens } = useUnstakedTokens();
  const t = useTranslations();
  const { consoleHistory, activeCommands, processCommand } = useTerminal();

  const handleExecuteCommand = (command: ICommandDefinition) => {
    processCommand(command);
  };

  return (
    <StakingConsole
      blockchain={blockchain}
      numberOfStaked={stakedTokens.length.toString()}
      numberOfUnstaked={unstakedTokens.length.toString()}
    >
      <CommandLineEntryStack>
        {consoleHistory.map(([prefix, Message], index) => (
          <CommandLineEntry key={index} prefix={prefix}>
            <ConsoleMessage>
              <Message />
            </ConsoleMessage>
          </CommandLineEntry>
        ))}
        {activeCommands.map((command, index) => (
          <CommandLineEntry key={index} centered id="staking-console-help">
            {t.rich(command.message, {
              button: (chunks) => (
                <CommandButton onClick={() => handleExecuteCommand(command)}>
                  {chunks}
                </CommandButton>
              ),
            })}
          </CommandLineEntry>
        ))}
        <CommandLineEntry withCursor centered prefix="P:" />
      </CommandLineEntryStack>
    </StakingConsole>
  );
};
